<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Priority Listing</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <priority-listing-form :data="data"></priority-listing-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import PriorityListingForm from './PriorityListingForm'
import { axios } from '../../../utils'
import FormErrors from '../../../components/FormErrors'
export default {
  name: 'PriorityListingDialog',
  data() {
    return {
      data: {
        id: null,
        name: '',
        email: '',
        active: false,
        verified: false,
        website: '',
        phone: '',
        mobile: '',
        facebook: '',
        youtube: '',
        instagram: '',
        address: '',
        category: '',
        suburb: '',
        anchor_suburb: '',
        plan: '',
        start_date: '',
        end_date: '',
        about: '',
        services: '',
        image: null
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'priority_listings', 'item'],
  components: {
    PriorityListingForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting priority_listings data for id ', this.item.id)
      axios
        .get('api/admin/priority-listings/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.data.anchor_suburb = this.data.anchor_suburb || this.data.suburb
          this.data.plan = this.normalizePlan(this.data.plan)
          this.data.phone = JSON.parse(res.data.contacts).phone
          this.data.mobile = JSON.parse(res.data.contacts).mobile

          this.data.facebook = JSON.parse(res.data.links).facebook
          this.data.youtube = JSON.parse(res.data.links).youtube
          this.data.instagram = JSON.parse(res.data.links).instagram
          this.loading = false
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new priority_listings')
      this.data.anchor_suburb = this.data.anchor_suburb || this.data.suburb
      this.data.plan = this.normalizePlan(this.data.plan)
      const formData = new FormData()
      for (const key in this.data) {
        if (key === 'active' || key === 'verified') {
          formData.append(key, this.data[key] ? 1 : 0)
        } else {
          formData.append(key, this.data[key])
        }
      }
      formData.append('contacts', JSON.stringify({
        phone: this.data.phone,
        mobile: this.data.mobile
      }))
      formData.append('links', JSON.stringify({
        facebook: this.data.facebook,
        instagram: this.data.instagram,
        youtube: this.data.youtube
      }))
      console.log(formData)
      axios
        .post('api/admin/priority-listings/create', formData)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating priority_listings data for id ', this.item.id)
      this.data.anchor_suburb = this.data.anchor_suburb || this.data.suburb
      this.data.plan = this.normalizePlan(this.data.plan)
      const formData = new FormData()
      for (const key in this.data) {
        if (key === 'active' || key === 'verified') {
          formData.append(key, this.data[key] ? 1 : 0)
        } else {
          formData.append(key, this.data[key])
        }
      }
      formData.append('contacts', JSON.stringify({
        phone: this.data.phone,
        mobile: this.data.mobile
      }))
      formData.append('links', JSON.stringify({
        facebook: this.data.facebook,
        instagram: this.data.instagram,
        youtube: this.data.youtube
      }))
      formData.append('_method', 'PUT')
      axios
        .post(`api/admin/priority-listings/${this.item.id}`, formData)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        id: null,
        name: '',
        email: '',
        active: false,
        verified: false,
        website: '',
        phone: '',
        mobile: '',
        facebook: '',
        youtube: '',
        instagram: '',
        address: '',
        category: '',
        suburb: '',
        anchor_suburb: '',
        plan: '',
        start_date: '',
        end_date: '',
        about: '',
        services: '',
        image: null
      }
    },
    normalizePlan(value) {
      if (value === null || value === undefined) {
        return ''
      }
      if (value === '3 Month') {
        return '3'
      }
      if (value === '12 Month') {
        return '12'
      }
      return String(value)
    }
}
,
  watch: {}
}
</script>

<style lang="scss" scoped></style>
